import { withFeatureBranch } from '../redux/flags';
import { Tooltip as BaseTooltip } from './Tooltip';
import { default as TooltipManager } from './TooltipManager';
export { default } from './Tooltip';
export { BaseTooltip, TooltipManager };
import { default as TooltipPopper } from './TooltipPopper';
import { default as TooltipPopperV2, } from './TooltipPopper.v2';
var FeatureProtectedPopper = withFeatureBranch({
    tooltips_ui_updates: TooltipPopperV2,
})(TooltipPopper);
export { FeatureProtectedPopper as TooltipPopper };
//# sourceMappingURL=index.js.map